// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"x4-z","colorTextValue":"y4-z","swatches":"z4-z","collapseLink":"A4-z","isCollapsed":"B4-z","dropdown":"C4-z","disabled":"D4-z"};